<!-- eslint-disable vue/require-default-prop -->
<script lang="ts" setup>
import { AlertTriangleIcon } from '@gohighlevel/ghl-icons/24/outline'
import {
  UICheckbox,
  UIModal,
  UIModalFooter,
  UIModalHeader,
} from '@gohighlevel/ghl-ui'
import { computed, ref } from 'vue'
const props = defineProps({
  showModal: Boolean,
  title: String,
  onCancelClick: Function,
  onConfirmClick: Function,
  desc: String,
  settings: Array,
  isSaveButtonDisabled: Boolean,
})
const isConsentChecked = ref(false)

const disableSaveButton = computed(() => {
  return isConsentChecked.value === false || props.isSaveButtonDisabled
})
</script>

<template>
  <UIModal :show="showModal" :width="600">
    <template #header>
      <UIModalHeader
        id="calendarGroupCreateModalHeader"
        type="warning"
        :title="title"
        :icon="AlertTriangleIcon"
        @close="onCancelClick"
      />
    </template>

    <div class="w-full">
      <div class="text-[14px] font-normal text-gray-700" v-html="desc" v-if="desc" />

      <div class="mt-3">
        <ul
          v-for="(data, index) in settings"
          :key="index"
          class="list-disc pl-4"
        >
          <li
            class="text-[13px] font-normal leading-6 text-gray-600"
            v-html="data"
          />
        </ul>
      </div>

      <slot name="body" />

      <div
        class="mt-3 text-[14px] font-normal text-gray-700"
        v-html="$t('settings.calendar.settings_confirmation')"
      />

      <div class="mt-3 flex items-center">
        <UICheckbox id="automation-checkbox" v-model:checked="isConsentChecked">
          <div class="text-[14px] font-normal text-gray-600">
            {{ $t('settings.calendar.consent_checkbox_title') }}
          </div>
        </UICheckbox>
      </div>
    </div>

    <div class="mt-[20px] w-full border-[0.8px] border-solid border-gray-200" />

    <template #footer>
      <UIModalFooter
        id="dependent-settings-footer"
        :positive-text="$t('settings.calendar.confirm')"
        :negative-text="$t('settings.calendar.cancel')"
        :type="'primary'"
        :disabled="disableSaveButton"
        @positive-click="onConfirmClick"
        @negative-click="onCancelClick"
      />
    </template>
  </UIModal>
</template>
